import type { ToastProperties } from '#components/Toast'
import type { ToastId } from './useCreateToastContext'

export const toaster: {
  add: (toast: ToastProperties) => ToastId
  remove: (id: ToastId) => void
} = {
  add: () => {
    throw new Error('Toaster not provided')
  },
  remove: () => {
    throw new Error('Toaster not provided')
  },
}
